import * as React from 'react';

const ThemeContext = React.createContext(null);

export { ThemeContext };
